import { RG_TYPE, ModuleLikeTypes } from "@project-rouge/rg-core";
import { DeepFindRgObject } from "@project-rouge/rg-three";
import { getActiveBuildings } from "./index183.js";
const pipeMatchFloors = ([parent, { buildingIds, aggProps }]) => {
  const dataset = aggProps.dataset;
  const buildings = getActiveBuildings(parent, aggProps);
  for (const building of buildings) {
    if (buildingIds && !buildingIds.includes(building.uuid))
      continue;
    const children = building.children.filter((c) => c.type !== RG_TYPE.Apartment);
    for (const child of children) {
      const moduleLikes = [];
      if (child.type === RG_TYPE.TechnicalSpace)
        moduleLikes.push(...child.children.filter((c) => c.type === RG_TYPE.Module));
      else if (ModuleLikeTypes.includes(child.type))
        moduleLikes.push(child);
      for (const module of moduleLikes) {
        const floor = DeepFindRgObject(module, (o) => o.type === RG_TYPE.Floor);
        if (floor) {
          floor.pos[1] = dataset.floorOffset - module.anchor[1] * module.size[1];
          floor.anchor[1] = 1;
        }
      }
    }
  }
  return [parent, void 0];
};
export {
  pipeMatchFloors
};
//# sourceMappingURL=index104.js.map
